import { render, staticRenderFns } from "./dialog_position.vue?vue&type=template&id=274ca0a9&scoped=true&"
import script from "./dialog_position.vue?vue&type=script&lang=js&"
export * from "./dialog_position.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ca0a9",
  null
  
)

export default component.exports